import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { DialogActionType, DialogConfig } from '../dialogs/dialog-types';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { LiveFormsTranslateLoaderService } from '../../services/live-forms-translate-loader.service';

const MAX_DIALOG_WIDTH = '500px';

@Injectable({
  providedIn: 'root'
})
export class EditorDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly translateService = inject(LiveFormsTranslateLoaderService);

  async showUserPrompt(config: DialogConfig): Promise<DialogActionType> {
    const dialogRef = this.dialog.open<ConfirmDialogComponent, DialogConfig, DialogActionType>(ConfirmDialogComponent, {
      minWidth: 'fit-content',
      maxWidth: MAX_DIALOG_WIDTH,
      data: config,
      disableClose: !config.allowClickOutside
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    return result ?? 'cancel';
  }

  async showErrorDialog(title: string, message: string): Promise<void> {
    await this.showUserPrompt({
      title,
      message,
      icon: 'error',
      iconColor: '#f44336',
      actions: [
        {
          text: this.translateService.instant('liveforms-editor.common.buttons.ok'),
          action: 'ok',
          color: 'primary',
          variant: 'raised'
        }
      ]
    });
  }
}
